module.exports = __webpack_public_path__ + "static/img/LostIsland.d429239.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/LostIsland.jpg
// module id = MMJd
// module chunks = 1